import appConst from '@/const/app.const';
import request from '../../../request';
/** 上传图片获取图片链接 */
export const upload = async (url: any) => {
  const res = await request.post(
    {
      action: 'user.account.upload',
      type: 2,
      image: 1,
      file: url,
    },
    { apiServer: appConst.UPLOAD_APP_API },
    true,
  );
  return res.url;
};

